import { render } from "./ColleagueInviteField.vue?vue&type=template&id=46000df6"
import script from "./ColleagueInviteField.vue?vue&type=script&lang=js"
export * from "./ColleagueInviteField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__